// @flow

const emptyCounters = () => ({
  http: 0,
  p2p: 0,
  upload: 0,
})

let counters = emptyCounters()
let peers = []
let bound = false
let player = null

export const p2pStatsCollector = {
  reset() {
    counters = emptyCounters()
    peers = []
  },
  setBound(value: boolean) {
    bound = value
  },
  setPlayer(value: Object) {
    player = value
  },
  getPlayer(): Object {
    return player
  },
  addDownloaded(bytes: number, source: string) {
    if (source === 'p2p') {
      counters.p2p += bytes
    } else if (source === 'http') {
      counters.http += bytes
    }
  },
  addUploaded(bytes: number) {
    counters.upload += bytes
  },
  addPeer(peer: Object) {
    peers = [...peers, peer]
  },
  removePeer(peer: Object) {
    peers = peers.filter(item => !(item.peerId === peer.peerId && item.infoHash === peer.infoHash))
  },
  getSnapshot() {
    return {
      bound,
      peerCount: new Set(peers.map(peer => peer.peerId)).size,
      bytes: {
        ...counters,
      },
    }
  },
}

export const getP2PStatsSnapshot = () => p2pStatsCollector.getSnapshot()
